<template>
  <div class="container">
    <div class="search-box">
      <div class="search van-hairline--bottom">
        <div class="left">
          <img class="icon" src="@/assets/image/back.png"  @click="onGoBack" />
        </div>
        <div class="middle">
          <img class="icon" src="@/assets/image/brand-search-icon.png" alt="">
          <input type="text" v-model="inputValue" placeholder="搜索店铺内商品" @keyup.enter="onSearch" />
        </div>
        <div class="right">
          <span @click="onSearch">搜索</span>
        </div>
      </div>
    </div>
    <div v-if="status.loaded">
      <div class="block" v-show="!status.isEmpty && !status.showList">
        <div class="title">店铺热搜</div>
        <ul class="content">
          <li 
            v-for="(item, index) of hotKeywords" 
            :key="index" 
            @click="onSearch(item.searchWord)"
          >{{item.searchWord}}</li>
        </ul>
      </div>
      <emptyItem v-show="status.isEmpty && !status.showList" title="请点击上方搜索框输入商品关键字"/>
    </div>
    <List v-show="status.showList" :filter-offset-top="90" :branchid="this.formData.brandId" ref="listRef"></List>
  </div> 
</template>
<script>
import utils from '@/utils/common'
import http from "@/utils/axios";
import search from './components/search';
import emptyItem from '../shareDiscovery/components/emptyItem'
import List from './components/list';
export default {
  data(){
    return{
      formData:{},
      inputValue: '',
      hotKeywords: [],
      status: {
        loaded: false,
        isEmpty: false,
        showList: false
      }
    }
  },
  methods:{
    init(){
      this.formData={
        ...this.$route.query
      }
      this.getHotKeywords()
    },
    onSearch(val){
      this.status.showList = true;
      this.$refs["listRef"].showRightMode = false;
      this.$refs["listRef"].keyword = val || this.inputValue;
      this.$refs["listRef"].setInitRequstData();
    },
    onGoBack() {
      this.$minicode.show({pageCode:'5010301',pageQueryParam:this.$route.query});
      utils.goBack();
    },
    getHotKeywords() {
      http({
        url: '/order/admin/branch/searchWord/queryList',
        method: 'post',
        parmes: {
          branchId: this.formData.brandId
        }
      }).then(data => {
        if(data.code === 200 && (data = data.data)) {
          this.hotKeywords = data
          this.status.loaded = true
          this.status.isEmpty = !data.length
        }
      })
    }
  },
  components:{search,emptyItem,List},
  created(){
    this.$loading.hide();
    this.init();
  },
  mounted() {
    if(this.$route.query.categoryId) {
      this.onSearch()
    }
  }
}
</script>
<style lang="less" scoped>
.container {
  min-height: 100vh;
  background-color: #ffffff;
  font-size: 28px;
  /deep/.empty_warp {
    margin-top: 29vh;
    .empty_info {
      color: #333333;
    }
  }
}
.search-box {
  height: 90px;
}
.search {
  display: flex;
  align-items: center;
  text-align: center;
  font-size: 28px;
  height: 90px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  background-color: #ffffff;
  .icon {
    width: 40px;
    height: 40px;
  }
  .left {
    width: 100px;
    display: flex;
    align-items: center;
    padding-left: 15px;
    box-sizing: border-box;
  }
  .middle {
    flex: 1;
    position: relative;
  }
  .middle .icon {
    position: absolute;
    top: 50%;
    left: 10px;
    z-index: 1;
    transform: translateY(-50%);
  }
  input {
    border: 0;
    outline: 0;
    background-color: #f5f5f5;
    width: 100%;
    height: 60px;
    line-height: 60px;
    border-radius: 30px;
    box-sizing: border-box;
    padding-left: 60px;
    padding-right: 30px;
  }
  .right {
    width: 140px;
    span {
      display: inline-block;
      width: 100px;
      height: 60px;
      line-height: 60px;
      border-radius: 30px;
      background-color: #F8D541;
      font-size: 24px;
      font-weight: bold;
    }
  }
}
.block {
  .title {
    height: 80px;
    line-height: 80px;
    font-weight: bold;
    padding: 0 40px;
  }
  ul {
    font-size: 0;
    padding-left: 40px;
    padding-right: 30px;
  }
  li {
    display: inline-block;
    height: 50px;
    line-height: 50px;
    padding: 0 26px;
    background-color: #F2F2F2;
    border-radius: 10px;
    font-size: 24px;
    color: #999999;
    margin-right: 10px;
    margin-bottom: 10px;
  }
}
</style>